import { render, staticRenderFns } from "./LeaderBoardDetial.vue?vue&type=template&id=9b992dd6&scoped=true"
import script from "./LeaderBoardDetial.vue?vue&type=script&lang=js"
export * from "./LeaderBoardDetial.vue?vue&type=script&lang=js"
import style0 from "./LeaderBoardDetial.vue?vue&type=style&index=0&id=9b992dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b992dd6",
  null
  
)

export default component.exports